import { authFetch } from '../lib/auth-fetch';
import { getBackendUrl } from '@/lib/api-config';

export type Integration = {
  id: string;
  product: string;
  adminUser: string;
  subscriptionId: string;
  subscriptionKey: string;
  applicationToken: string;
  createdAt: string;
  updatedAt: string;
}

export type IntegrationCreate = {
  product: string;
  adminUser: string;
  subscriptionId: string;
  subscriptionKey: string;
  applicationToken: string;
}

class IntegrationService {
  async getAll(): Promise<Integration[]> {
    const API_BASE_URL = getBackendUrl();
    const url = `${API_BASE_URL}/api/Integration`;
    
    const response = await authFetch(url);
    if (!response.ok) {
      throw new Error('Failed to fetch integrations');
    }
    return response.json();
  }

  async getById(id: string): Promise<Integration> {
    const API_BASE_URL = getBackendUrl();
    const url = `${API_BASE_URL}/api/Integration/${id}`;
    
    const response = await authFetch(url);
    if (!response.ok) {
      throw new Error('Failed to fetch integration');
    }
    return response.json();
  }

  async create(integration: IntegrationCreate): Promise<Integration> {
    const API_BASE_URL = getBackendUrl();
    const url = `${API_BASE_URL}/api/Integration`;
    
    const response = await authFetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...integration, product: 'Expense' }),
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Failed to create integration');
    }
    return response.json();
  }

  async update(id: string, integration: IntegrationCreate): Promise<void> {
    const API_BASE_URL = getBackendUrl();
    const url = `${API_BASE_URL}/api/Integration/${id}`;
    
    const response = await authFetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...integration, product: 'Expense' }),
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Failed to update integration');
    }
  }

  async delete(id: string): Promise<void> {
    const API_BASE_URL = getBackendUrl();
    const url = `${API_BASE_URL}/api/Integration/${id}`;
    
    const response = await authFetch(url, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error('Failed to delete integration');
    }
  }
}

export const integrationService = new IntegrationService();
